module.exports = __webpack_public_path__ + "static/img/020_8.ebdf7db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/020_8.jpg
// module id = cURm
// module chunks = 1